import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Header } from 'semantic-ui-react';

import LobItem from './LobItem';

type Props = {
  id: any,
  name: string,
  items: Object,
  addAccount: Function,
  removeAccount: Function,
  loading: boolean
};

const Container = styled.div`
  margin-bottom: 20px;
  background: #fff;
  padding: 15px;
  border-radius: 3px;
  box-shadow: 2px 2px 5px #ddd;
`;
const NoPreview = styled.div`
  width: 250px;
  margin: 20px 20px 0;
  padding: 6px 18px;
  border: 1px solid #969696;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const NoPreviewText = styled.h4`
  color: rgba(0, 0, 0, 0.6);
  margin: 0 !important;
`;
const ListContainer = styled.div`
  border-left: 1px solid #969696;
  padding-bottom: 5px;
`;
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

class LobComponent extends Component<Props> {
  renderList = () => {
    const { id, items, removeAccount } = this.props;

    if (Object.keys(items).length > 0) {
      return (
        <div>
          {Object.keys(items).map((key) => (
            <LobItem key={key} lobId={id} id={key} item={items[key]} removeAccount={removeAccount} />
          ))}
        </div>
      );
    }

    return (
      <NoPreview>
        <NoPreviewText>No Accounts Setup Yet</NoPreviewText>
      </NoPreview>
    );
  };

  render() {
    const { id, name, addAccount, loading, onDelete } = this.props;
    return (
      <Container>
        <Header as="h3">{name}</Header>
        <ListContainer>
          {this.renderList()}
          <ButtonContainer>
            <Button
              primary
              icon="plus"
              labelPosition="right"
              content="Add Source"
              onClick={() => addAccount(id)}
              style={{ margin: 15 }}
              loading={loading}
            />
            <Button
              color="red"
              icon="trash"
              labelPosition="right"
              content="Delete LOB"
              onClick={() => onDelete(id)}
              style={{ marginTop: 15, marginBottom: 15 }}
              loading={loading}
            />
          </ButtonContainer>
        </ListContainer>
      </Container>
    );
  }
}

export default LobComponent;



// WEBPACK FOOTER //
// ./src/components/share/Lob.js